<template>
    <div class="edit-table">
        <div class="padding_50">
            <vxe-table :data="budgetsList">

                <!-- <vxe-table-column min-width="100" field="cashAward" title="现金奖励">
                </vxe-table-column> -->
                <vxe-table-column min-width="100" field="executeCode" title="执行编码">
                </vxe-table-column>
                <vxe-table-column min-width="100" field="awardType" title="奖励类型">
                    <template #default="{ row }">
                        <span v-if="row.awardType === '0'">消费者开瓶</span>
                        <span v-if="row.awardType === '2'">宴席跟单奖励</span>
                        <span v-if="row.awardType === '4'">消费者买赠</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column min-width="100" field="productCode" title="产品编码">
                </vxe-table-column>
                <vxe-table-column min-width="100" field="productName" title="产品名称">
                </vxe-table-column>
                <vxe-table-column min-width="100" field="giftNum" title="赠酒数量（瓶）">
                </vxe-table-column>
                <vxe-table-column min-width="100" field="actualGiftNum" title="实际赠酒数量（瓶）">
                </vxe-table-column>
                <vxe-table-column min-width="100" field="productPrice" title="产品单价">
                </vxe-table-column>
                <vxe-table-column min-width="100" field="cashAward" title="核销金额">
                </vxe-table-column>
            </vxe-table>
        </div>
        <!-- 弹框 -->
        <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
    </div>
</template>

<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'configProducts',
  components: {
    SelectConfig,
  },
  props: {
    value: Array,
    disabled: Boolean,
  },
  watch: {
    value: {
      handler(val) {
        this.budgetsList = val || [];
      },
      deep: true,
    },
    disabled(val) {
      console.log('🚀 ~ disabled ~ val:', val);
    },
  },
  data() {
    return {
      budgetsList: [], // 当前关联费用科目数据
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.budgetsList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log(this.budgetsList, 'budgetsList');
        this.budgetsList.splice(rowIndex, 1);
        this.$emit('input', this.budgetsList);
      });
    },
    deleteTable() {
      this.budgetsList = [];
      this.$emit('input', []);
    },
    // 打开点击弹窗产品名称
    productNameClick(index) {
      const params = {
        data: this.budgetsList,
        selectionList: [],
        functionCode: 'budgetsList',
        idKey: 'budgetsCode',
        noReset: true,
        paramData: {
          enableStatus: '009',
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      const data = this.getReset(val, [], 'id');
      this.budgetsList = this.getReset(this.budgetsList.concat(data), [], 'id');
      this.budgetsList = this.budgetsList.map((item, index) => ({
        budgetSubjectCode: item.budgetSubjectsCode,
        budgetSubjectName: item.budgetSubjectsName,
        companyCode: item.ext7,
        companyName: item.ext8,
        feeBudgetCode: item.feeBudgetCode,
        feeBudgetType: item.feeBudgetType,
        fiscalYear: item.ext1,
        levelNum: item.levelNum || index + 1,
      }));
      this.$emit('input', this.budgetsList);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },

  },
};
</script>

<style lang="less" scoped>
  .edit-table {
    padding-left: 50px;
    margin-left: 0 !important;
  }
</style>
